import { PortalPair } from './utils/portal-pair';

export const SubHeaderPortal = new PortalPair('SubHeader');
